const Footer = () => {
    return (
        <footer>
            <p>
                Copyright © 2023 Terciel-22 | All Rights Reserve
            </p>
        </footer>
    )
}

export default Footer